var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('section', {
    staticClass: "sub-visual"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap mb-24 mb-md-50 mb-lg-0"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl"
  }, [_vm._v(" Company ")])], 1)]), _c('v-img', {
    staticClass: "sub-visual__img",
    attrs: {
      "src": "/images/sub/company/sub-visual-company.jpg"
    }
  }), _c('sub-tab', {
    attrs: {
      "page": "회사소개",
      "tabActive": 2
    }
  })], 1), _c('section', {
    staticClass: "sub-section sub-section--history"
  }, [_c('v-container', {
    staticClass: "page-text"
  }, [_c('v-row', {
    staticClass: "mb-50 mb-md-100",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "pr-xl-24"
  }, [_c('v-card', {
    staticClass: "mb-24",
    attrs: {
      "flat": "",
      "max-width": "608",
      "data-aos": "fade-left"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/company/history/history01.jpg"
    }
  })], 1)], 1)]), _c('v-col', {
    attrs: {
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "history-list history-list--top"
  }, [_c('v-row', {
    staticClass: "row--large"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 1997 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 오뚜기 CFC 설립 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 1998 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 오뚜기 에덴 인수합병 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 1999 ")]), _c('span', {
    staticClass: "grey--text font-pretendard"
  }, [_vm._v(" (주)하림 계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2000 ")]), _c('span', {
    staticClass: "grey--text font-pretendard"
  }, [_vm._v(" (주)멕시칸 계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2001 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" OUTBACK STEAK HOUSE 전지점 계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2002 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" BBQ 본사 소스원료 납품계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2004 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 버거킹 전지점 납품계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2005 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 미스터 피자 납품계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2006 ")]), _c('span', {
    staticClass: "grey--text font-pretendard"
  }, [_vm._v(" \"(주)모두에프엔티\"로 상호변경 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2008 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 해피궁 서울/경기북부지사 납품계약체결, 연매출 100억달성 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2009 ")]), _c('span', {
    staticClass: "grey--text font-pretendard"
  }, [_vm._v(" 롯데리아, 본스, CJ프러시웨이(CGV), 시아스 납품계약체결 ")])], 1)])], 1), _c('v-img', {
    staticClass: "center-line d-none d-md-block",
    attrs: {
      "max-width": "24",
      "src": "/images/sub/company/history/center-line01.png"
    }
  })], 1)])], 1), _c('v-row', {
    staticClass: "d-md-none",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-24 mb-md-0",
    attrs: {
      "flat": "",
      "max-width": "608",
      "data-aos": "fade-left"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/company/history/history02.jpg"
    }
  })], 1)], 1), _c('v-col', [_c('div', {
    staticClass: "history-list history-list--top"
  }, [_c('v-row', {
    staticClass: "row--large"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex align-center"
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2013 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 스시로 전지점 물류 계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2014 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 도니버거, 효소원, 물류계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2015 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 육대장 계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2016 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 서브원 물품공급 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2017 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 베베쿡 계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2018 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 쿠우쿠우 매장 11곳 납품계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2019 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 오늘애 김밥, 달테이블, 영동 씨푸드 납품계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2020 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 마키노차야 뷔페, 텐미닛 쿡 계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2021 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 정돈 돈까스 납품계약체결 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2022 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 교산동에서 창우동으로 회사 장소 이전 ")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "max-width": "100",
      "src": "/images/sub/company/history/line.png"
    }
  }), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px mr-8",
    attrs: {
      "align": "left"
    }
  }, [_vm._v(" 2023 ")]), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 카페프루츠 수주계약, 유로베이크 대리점 계약 및 베이커리&카페 사업 확장 예정 ")])], 1)])], 1), _c('v-img', {
    staticClass: "center-line d-none d-md-block",
    attrs: {
      "max-width": "24",
      "src": "/images/sub/company/history/center-line01.png"
    }
  })], 1)])], 1), _c('v-row', {
    staticClass: "d-none d-md-flex",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "history-list history-list--bottom"
  }, [_c('v-row', {
    staticClass: "row--large"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 스시로 전지점 물류 계약체결 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2013 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 도니버거, 효소원, 물류계약체결 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2014 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 육대장 계약체결 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2015 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 서브원 물품공급 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2016 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 베베쿡 계약체결 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2017 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 쿠우쿠우 매장 11곳 납품계약체결 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2018 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 오늘애 김밥, 달테이블, 영동 씨푸드 납품계약체결 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2019 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 마키노차야 뷔페, 텐미닛 쿡 계약체결 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2020 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 정돈 돈까스 납품계약체결 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2021 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 교산동에서 창우동으로 회사 장소 이전 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2022 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "history-list__li d-flex",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 카페프루츠 수주계약, 유로베이크 대리점 계약 및 베이커리 &카페 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 사업 확장 예정 ")]), _c('span', {
    staticClass: "font-weight-medium w-44px w-md-60px ml-8",
    attrs: {
      "align": "right"
    }
  }, [_vm._v(" 2023 ")]), _c('v-img', {
    staticClass: "mx-24 d-none d-md-inline-block",
    attrs: {
      "width": "100",
      "max-width": "100",
      "aspect-ratio": "100/30",
      "src": "/images/sub/company/history/line.png"
    }
  })], 1)])], 1), _c('v-img', {
    staticClass: "d-none d-md-block center-line",
    attrs: {
      "max-width": "24",
      "src": "/images/sub/company/history/center-line02.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6",
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pl-xl-24"
  }, [_c('v-card', {
    staticClass: "mt-40 mt-xl-0",
    attrs: {
      "flat": "",
      "max-width": "608",
      "data-aos": "fade-right"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/company/history/history02.jpg"
    }
  })], 1)], 1)])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }